import React from "react"
import {Route, Redirect} from "react-router-dom"
import {connect} from "react-redux"
import PropTypes from "prop-types"

const GuestRoute = ({isAuthenticated, component: Component, ...rest}) => (
  <Route
    {...rest}
    render={props =>
      !isAuthenticated ? <Component {...props} /> : <Redirect to="/home" />
    }
  />
)

GuestRoute.propTypes = {
  component: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
}

const mapStateToProps = ({auth}) => {
  const {isAuthenticated} = auth
  return {
    isAuthenticated
  }
}

export default connect(mapStateToProps)(GuestRoute)



// WEBPACK FOOTER //
// ./src/components/routes/GuestRoute.js